window.__splideMounted = window.__splideMounted || {}; // { [sectionId]: { main, thumbs } }
function mountSplideGallery(sectionId, startIndex) {
  if (window.__splideMounted[sectionId])
    return window.__splideMounted[sectionId];

  var mainEl = document.querySelector("#splide-main-" + sectionId);
  var thumbsEl = document.querySelector("#splide-thumbs-" + sectionId);
  if (!mainEl || !thumbsEl || typeof Splide === "undefined") return null;

  var main = new Splide(mainEl, {
    type: "slide",
    rewind: true,
    pagination: false,
    arrows: true,
    gap: "10px",
    start: startIndex || 0,
    drag: true,
  });

  // === Solo 4 visibles ===
  var GAP = 10; // Debe coincidir con tu CSS
  var SIZE_DESKTOP = 96; // Tamaño del thumb en desktop
  var SIZE_MOBILE = 80; // Tamaño del thumb en mobile
  var VHEIGHT = SIZE_DESKTOP * 4 + GAP * 3; // alto para ver 4 thumbs

  var thumbs = new Splide(thumbsEl, {
    direction: "ttb", // vertical en desktop
    height: VHEIGHT + "px", // 4 visibles
    fixedWidth: SIZE_DESKTOP,
    fixedHeight: SIZE_DESKTOP,
    gap: GAP + "px",
    pagination: false,
    arrows: false,
    isNavigation: true,
    wheel: true,
    focus: "center",
    breakpoints: {
      989: {
        direction: "ltr", // horizontal en mobile
        // Mostramos exactamente 4 por página
        perPage: 4,
        fixedWidth: undefined, // dejamos que Splide calcule por perPage
        fixedHeight: undefined,
        height: "auto",
        gap: GAP + "px",
      },
    },
  });

  main.sync(thumbs);
  thumbs.mount();
  main.mount();

  window.__splideMounted[sectionId] = { main, thumbs };
  return window.__splideMounted[sectionId];
}

function destroySplideGallery(sectionId) {
  var pair = window.__splideMounted[sectionId];
  if (!pair) return;
  try {
    pair.main.destroy(true);
  } catch (e) {}
  try {
    pair.thumbs.destroy(true);
  } catch (e) {}
  delete window.__splideMounted[sectionId];
}

/* ============================================================
  Tu código existente + QuickView con reinicialización de Splide
============================================================ */
document.addEventListener("DOMContentLoaded", () => {
  // -------- Menú (tu lógica original) --------
  const menuChildren = document.querySelectorAll(
    ".mega-menu-subitem .li-has-children"
  );
  menuChildren.forEach((menuGrandChild) => {
    const submenu = menuGrandChild.querySelector("ul");
    const header = menuGrandChild.querySelector("h2");
    if (submenu && header) {
      header.style.cursor = "pointer";
      header.addEventListener("click", () => {
        header.classList.toggle("active");
        submenu.classList.toggle("active");
      });
    }
  });

  // -------- Si hay una galería Splide ya en la página (PDP normal), móntala --------
  document.querySelectorAll("[data-product-root]").forEach((root) => {
    var sectionId = root.getAttribute("data-product-root");
    // intenta montar (si existe el markup de Splide)
    mountSplideGallery(sectionId, 0);
  });

  // -------- Quick View --------
  const quickViewModal = document.getElementById("QuickViewModal");
  const contentContainer = quickViewModal
    ? quickViewModal.querySelector("[data-quick-view-container]")
    : null;

  if (!quickViewModal || !contentContainer) return;

  function openModal() {
    quickViewModal.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    // Destruir cualquier Splide montado dentro del quick view actual
    const root = contentContainer.querySelector("[data-product-root]");
    if (root) {
      const sid = root.getAttribute("data-product-root");
      destroySplideGallery(sid);
    }
    quickViewModal.classList.remove("is-open");
    document.body.style.overflow = "";
    contentContainer.innerHTML =
      '<div class="loading-spinner">Loading...</div>';
  }

  const closeButton = quickViewModal.querySelector(".modal__close-button");
  if (closeButton) closeButton.addEventListener("click", closeModal);
  quickViewModal.addEventListener("click", (event) => {
    if (event.target === quickViewModal) closeModal();
  });

  // Apertura desde cada botón
  document.querySelectorAll(".quick-view-button").forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      const productHandle = event.currentTarget.dataset.productHandle;

      openModal();
      contentContainer.innerHTML =
        '<div class="loading-spinner">Loading...</div>';

      const url = `/products/${productHandle}?sections=main-product-modal`;

      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          const productHtml = data["main-product-modal"];
          contentContainer.innerHTML = productHtml;

          // 1) Re-init del tema (variantes, formulario)
          const newProductRoot = contentContainer.querySelector(
            "[data-product-root]"
          );
          const newProductFormElement = contentContainer.querySelector(
            ".shopify-product-form"
          );

          if (newProductRoot && window.Theme && window.Theme.VariantSelects) {
            new window.Theme.VariantSelects(newProductRoot);
          }
          if (
            newProductFormElement &&
            window.Theme &&
            window.Theme.ProductForm
          ) {
            new window.Theme.ProductForm(newProductFormElement);
          }

          // 2) Montar Splide para esta sección recién inyectada
          if (newProductRoot) {
            const sectionId = newProductRoot.getAttribute("data-product-root");
            // si tienes una variable en el HTML que indique slide inicial, úsala. Aquí 0.
            mountSplideGallery(sectionId, 0);
          }
          // 3) 🚀 CIERRE AUTOMÁTICO DEL MODAL AL AÑADIR AL CARRITO (CON RETRASO)
          const addToCartButton =
            contentContainer.querySelector(".add-to-cart-btn");
          if (addToCartButton) {
            addToCartButton.addEventListener("click", () => {
              // Retrasa la llamada a closeModal por 1500 ms (1.5 segundos)
              setTimeout(closeModal, 1500);
            });
          }
        })
        .catch((error) => {
          console.error("Error al cargar la vista rápida:", error);
          contentContainer.innerHTML =
            "<p>Error al cargar el producto. Inténtalo de nuevo.</p>";
        });
    });
  });
});
